import React from "react";
import { Layout, SportsBonus } from "../components";

const SportsBonusPage = () => {
  return (
    <>
      <Layout>
        <SportsBonus />
      </Layout>
    </>
  );
};

export default SportsBonusPage;
